module.exports = __webpack_public_path__ + "img/graph.2e4a8906.svg";